<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">

        <div class="card-body">
          <div>
            <div class="row">
              <div class=col-12>
                <h4>Kontaktinformationen </h4>
                <hr />
              </div>

              <div class="col-12 col-xl-6" style="margin-bottom: 20px">
                <div class="form-group row mb-2">
                  <label for="validationDefault01" class="col-form-label col-sm-4">E-Mail</label>
                  <input required type="text" name="EMail" [(ngModel)]="customer.EMail" class="form-control col-sm-6"
                         placeholder="E-Mail">
                </div>
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Handynummer</label>
                  <input type="text" name="Telephone" [(ngModel)]="customer.Telephone" class="form-control col-sm-6"
                         placeholder="z.B. +49 151 12345678">
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-xl-3" style="margin-bottom: 20px">
                <h4>Benachrichtigungen des Geräts</h4>

                <div class="form-group row mb-2">
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="PrivateMessageByEMail" [(ngModel)]="customer.PrivateMessageByEMail"></ed-switch>
                  </div>
                  <label class="col-form-label col-sm-8">E-Mail</label>

                </div>
                <div class="form-group row mb-2">
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="PrivateMessageBySMS" [(ngModel)]="customer.PrivateMessageBySMS"></ed-switch>
                  </div>
                  <label class="col-form-label col-sm-8">SMS</label>

                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-xl-3" style="margin-bottom: 20px">
                <h4>Benachrichtigungen des Versorgers</h4>

                <div class="form-group row mb-2">
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="ProviderMessageByEMail" [(ngModel)]="customer.ProviderMessageByEMail"></ed-switch>
                  </div>
                  <label class="col-form-label col-sm-8">E-Mail</label>

                </div>
                <div class="form-group row mb-2">
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="ProviderMessageBySMS" [(ngModel)]="customer.ProviderMessageBySMS"></ed-switch>
                  </div>
                  <label class="col-form-label col-sm-8">SMS</label>

                </div>

              </div>
            </div>

            <div class="row m-t-20">
              <div class="col-12 col-sm-6 col-md-6 col-xl-6">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4 f-w-500">
                    <span *ngIf="alarms.LeakageAlarm.IsActive">Leckageerkennung ist eingeschaltet</span>
                    <span *ngIf="!alarms.LeakageAlarm.IsActive">Leckageerkennung ist ausgeschaltet</span>
                  </label>
                  <label class="col-form-label col-sm-2 col-xl-2">aus</label>
                  <div class="col-sm-1 col-xl-2 pt-2">
                    <ed-switch name="leakageAlarmIsActive" [(ngModel)]="alarms.LeakageAlarm.IsActive" (updateValue)="leakageAlarmValueChange($event)"></ed-switch>
                  </div>
                  <label class="col-form-label col-sm-1 col-xl-2">ein</label>
                </div>
              </div>
              <div class="col-12  col-xl-6">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-6 f-w-500">
                    <span *ngIf="customer.IsValveOpen">Ventil ist offen</span>
                    <span *ngIf="!customer.IsValveOpen">Ventil ist gschlossen</span>
                  </label>
                  <div class="col-sm-2 col-xl-2 pt-2">
                    <ed-switch name="IsValveOpen" [(ngModel)]="customer.IsValveOpen"></ed-switch>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-sm-6"></div>
              <div class="col-sm-6 col-xl-6">
                <label class="col-form-label text-danger d-i">{{valveSettingErrorMessage}}</label>
              </div>
            </div>

            <div class="row" style="margin-top:50px;">
              <div class=col-12>
                <h4>Erkennung von Mikroleckagen</h4>
                <hr />
              </div>
              <div class="col-12">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Tag der Druckprobe</label>
                  <div class="col-sm-4 p-l-0">
                    <select class="form-control" [(ngModel)]="alarms.PressureMeasurementDay" [disabled]="isLeakageAlarmInActive">
                      <option *ngFor="let day of days" [ngValue]="day.text">
                        {{ day.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <div class="col-sm-4">
                    <label class="col-form-label" style="margin-top: 28px;">Zeitpunkt der Druckprobe</label>
                  </div>
                  <div class="col-sm-4">
                    <ngb-timepicker [(ngModel)]="alarms.PressureMeasurementTime" [disabled]="isLeakageAlarmInActive"></ngb-timepicker>
                  </div>
                </div>
              </div>
            </div>

            <!--leakage detection-->
            <div class="row" style="margin-top:50px;">

              <div class="col-12" style="margin-bottom: 20px">
                <h4>Erkennung von Dauerdurchflüssen</h4>
                <hr />
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Zeitwert für unerlaubten Dauerdurchfluss</label>
                  <input type="text" name="permanentFlowAlarm" [(ngModel)]="alarms.PermanentFlowAlarm.Content"
                         class="form-control col-sm-2" placeholder="Minuten" [disabled]="isLeakageAlarmInActive">
                  <label class="col-form-label col-sm-2">min</label>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Maximaldurchfluss pro Tag</label>
                  <input type="text" name="maximumFlowAlarm" [(ngModel)]="alarms.MaximumFlowAlarm.Content"
                         class="form-control col-sm-2" placeholder="m³" [disabled]="isLeakageAlarmInActive">
                  <label class="col-form-label col-sm-2">m³</label>
                </div>
              </div>

            </div>


            <!--vent protection-->
            <div class="row" style="margin-top:50px;">
              <div class=col-12>
                <h4>Ventilschutz</h4>
                <hr />
              </div>

              <div class="col-12">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Tag an dem der Ventilschutz ausgeführt werden soll</label>
                  <div class="col-sm-4 p-l-0">
                    <select class="form-control" [(ngModel)]="sensor.VentProtectionDay">
                      <option *ngFor="let day of days" [ngValue]="day.text">
                        {{ day.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <div class="col-sm-4">
                    <label class="col-form-label" style="margin-top: 28px;">
                      Zeitpunkt an dem der Ventilschutz ausgeführt werden soll
                    </label>
                  </div>
                  <div class="col-sm-4">
                    <ngb-timepicker [(ngModel)]="ventProtectionTime"></ngb-timepicker>
                  </div>
                </div>
              </div>

            </div>



            <!--Frost protection-->
            <div class="row" style="margin-top:50px;">

              <div class="col-12" style="margin-bottom: 20px">
                <h4>Frostschutz</h4>
                <hr />
              </div>

              <div class="col-12">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">
                    <span *ngIf="sensor.IsAntifreesprotection">Frostschutz ist aktiv</span>
                    <span *ngIf="!sensor.IsAntifreesprotection">Frostschutz ist nicht aktiv</span>
                  </label>
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="antiFreesDetection" [(ngModel)]="sensor.IsAntifreesprotection"></ed-switch>
                  </div>
                </div>
              </div>

            </div>

            <!--holidy modus-->
            <div class="row" style="margin-top:50px;">

              <div class=col-12>
                <h4 class="color">Urlaubsmodus</h4>
                <hr />
              </div>

              <div class="col-12">
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Automatische Aktivierung des Urlaubsmodus</label>
                  <div class="col-sm-4 pt-2">
                    <ed-switch name="IsHolidayModus" [(ngModel)]="customer.IsHolidayModus"></ed-switch>
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-form-label col-sm-4">Aktivierung des Urlaubsmodus nach</label>
                  <input type="text" name="IntervallHolidayModus" [(ngModel)]="customer.IntervallHolidayModus"
                         class="form-control col-sm-2" placeholder="Stunden">
                  <label class="col-form-label col-sm-2">Std.</label>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="card-footer">
          <div class="row" style="margin-top:50px;">
            <div class="col-12">
              <button class="btn btn-primary" type="submit" (click)="save(customer);"
                [disabled]="isSubmitted">{{isSubmitted? 'Es wird gespeichert' : 'Speichern'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
